<template>
  <div>
    <client-navbar-inverse />
    <div>
      <slot />
    </div>
    <client-footer></client-footer>
  </div>
</template>

<script>
import ClientNavbarInverse from '@/components/client/ClientNavbarInverse'
import ClientFooter from '@/components/client/ClientFooter'

export default {
  components: {
    ClientNavbarInverse,
    ClientFooter
  }
}
</script>
